import instance from "@/services/api";

export const bimProjectsAPI = {
  async getList(params = {}) {
    return await instance().get('/handbook/bim_projects/read/', { params }).then(res => res?.data)
  },
  async save(data) {
    return await instance().post('/handbook/bim_projects/save/', data).then(res => res?.data)
  },
  async delete(bim_project_id) {
    return await instance().delete(`/handbook/bim_projects/${bim_project_id}/delete/`).then(res => res?.data)
  },
  async getDigitalProjectForImport(bim_project_id) {
    return await instance().get(`/handbook/bim_projects/${bim_project_id}/digital-project-for-import/`).then(res => res?.data)
  },
  async importJson(bim_project_id, formData) {
    return await instance().post(`/handbook/bim_projects/${bim_project_id}/import-json/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => res?.data)
  },
  async importExcel(bim_project_id, formData) {
    return await instance().post(`/handbook/bim_projects/${bim_project_id}/import-excel/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => res?.data)
  },
  
  // Справочники
  async getCategories(bim_project_id = null) {
    const params = {};
    if (bim_project_id) {
      params.bim_project_id = bim_project_id;
    }
    return await instance().get('/handbook/bim_projects/categories/read/', { params }).then(res => res?.data)
  },
  async getTypes() {
    return await instance().get('/handbook/bim_projects/types/read/').then(res => res?.data)
  },
  async getParams() {
    return await instance().get('/handbook/bim_projects/params/read/').then(res => res?.data)
  },
  
  // Items
  async getItems(bim_project_id, bim_category_id = null) {
    const params = {};
    if (bim_category_id) {
      params.bim_category_id = bim_category_id;
    }
    return await instance().get(`/handbook/bim_projects/${bim_project_id}/items/`, { params }).then(res => res?.data)
  },
  async getItemJson(bim_project_item_id) {
    return await instance().get(`/handbook/bim_projects/items/${bim_project_item_id}/param-json/`).then(res => res?.data)
  },
  async saveItem(data) {
    return await instance().post('/handbook/bim_projects/items/save/', data).then(res => res?.data)
  },
  async deleteItem(bim_project_item_id) {
    return await instance().delete(`/handbook/bim_projects/items/${bim_project_item_id}/delete/`).then(res => res?.data)
  },
  async deleteItems(bim_project_item_ids) {
    return await instance().post('/handbook/bim_projects/items/bulk-delete/', { bim_project_item_ids }).then(res => res?.data)
  },
  async copyItemsToFloors(bim_project_item_ids, bim_level_nums) {
    return await instance().post('/handbook/bim_projects/items/copy-to-floors/', { bim_project_item_ids, bim_level_nums }).then(res => res?.data)
  },
  async updateItemsLevel(bim_project_item_ids, bim_level_num) {
    return await instance().post('/handbook/bim_projects/items/update-level/', { bim_project_item_ids, bim_level_num }).then(res => res?.data)
  },

  // Floor schemes
  async getFloorSchemes(bim_project_id) {
    return await instance().get(`/handbook/bim_projects/${bim_project_id}/floor-schemes/`).then(res => res?.data)
  },
  async getFloorSchemeGeometry(bim_project_id, bim_level_num) {
    return await instance().get(`/handbook/bim_projects/${bim_project_id}/floor-schemes/geometry/`, {
      params: { bim_level_num }
    }).then(res => res?.data)
  },
  async saveFloorScheme(data) {
    return await instance().post('/handbook/bim_projects/floor-schemes/save/', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => res?.data)
  },
  async getBimTypesByCategory(bim_category_id) {
    return await instance()
      .get(`/handbook/bim_categories/${bim_category_id}/types/`)
      .then(res => res?.data)
  },
  async saveFloorSchemeCalibration(data) {
    return await instance().post('/handbook/bim_projects/floor-schemes/calibration/save/', data).then(res => res?.data)
  },
  async copyFloorSchemeToFloors(data) {
    return await instance().post('/handbook/bim_projects/floor-schemes/copy-to-floors/', data).then(res => res?.data)
  },
  async deleteFloorScheme(bim_project_floor_scheme_id) {
    return await instance().delete(`/handbook/bim_projects/floor-schemes/${bim_project_floor_scheme_id}/delete/`).then(res => res?.data)
  },
  
  // Типы линий
  async getFloorParamTypes() {
    return await instance().get('/handbook/bim_projects/floor-param-types/read/').then(res => res?.data)
  },
  
  // Calc значения
  async getCalcTypes(calc_type_codes) {
    // Axios автоматически преобразует массив в формат ?calc_type_codes=value1&calc_type_codes=value2
    const params = {
      calc_type_codes: calc_type_codes
    };
    return await instance().get('/handbook/bim_projects/calc-types/read/', { params }).then(res => res?.data)
  },
  async getCalcTypesByProjectType(project_type_code) {
    const params = {
      project_type_code: project_type_code
    };
    return await instance().get('/handbook/bim_projects/calc-types/read/', { params }).then(res => res?.data)
  },
  async getCalcTypesByProjectId(bim_project_id) {
    const params = {
      bim_project_id: bim_project_id
    };
    return await instance().get('/handbook/bim_projects/calc-types/read/', { params }).then(res => res?.data)
  },
  async getCalcValues(bim_project_id) {
    return await instance().get(`/handbook/bim_projects/${bim_project_id}/calc-values/read/`).then(res => res?.data)
  },

  // Новые упрощенные методы для параметров расчета
  async getCalcParams(bim_project_id) {
    return await instance().get(`/handbook/bim_projects/${bim_project_id}/calc-params/read/`).then(res => res?.data)
  },
  async saveCalcParams(bim_project_id, params) {
    return await instance().post(`/handbook/bim_projects/${bim_project_id}/calc-params/save/`, { params }).then(res => res?.data)
  }
}

